import { Col, Row } from 'antd';
import { t } from 'i18next';
import { observer } from 'mobx-react-lite';
import { Card } from 'src/components/Card/Card';
import { DataView } from 'src/components/DataView/DataView';
import { LoanApplicationDto } from 'src/generated-api-client';

type AgentLoanApplicationPartnerInfoProps = {
    application?: LoanApplicationDto;
};

export const AgentLoanApplicationPartnerInfo = observer(
    ({ application }: AgentLoanApplicationPartnerInfoProps) => {
        if (!application?.assignedPartner) {
            return null;
        }

        return (
            <Card title={t('Agent.LoanApplication.PartnerInfo.Title')}>
                <Row gutter={[16, 16]}>
                    <Col xs={24} sm={12} md={12}>
                        <DataView
                            label={t(
                                'Agent.LoanApplication.PartnerInfo.AssignedAt',
                            )}
                            value={application.assignedAt}
                            formatValue="dateTimeSeconds"
                        />
                    </Col>
                    <Col xs={24} sm={12} md={12}>
                        <DataView
                            label={t(
                                'Agent.LoanApplication.PartnerInfo.ProductID',
                            )}
                            value={application.product?.number}
                        />
                    </Col>
                    <Col xs={24} sm={12} md={12}>
                        <DataView
                            label={t(
                                'Agent.LoanApplication.PartnerInfo.ProductName',
                            )}
                            value={application.product?.name}
                        />
                    </Col>
                </Row>
            </Card>
        );
    },
);
